<template>
  <div class="text-sm text-gray-800">
    <StoreDetailsCard
      v-if="storeId"
      v-bind="{
        ...props,
      }"
      :title="props.name"
      size="small"
      :is-map-visible="false"
      :padded-address="false"
      :more-opening-hours-on-store-page="true"
    >
      <template #below-store-info>
        <div class="flex items-center justify-end pt-4 font-bold">
          <CLink variant="primary" size="small" :to="`/butiker/${storeId}`">
            {{ t('store.go_to_the_store_page') }}
          </CLink>
        </div>
      </template>
    </StoreDetailsCard>
    <RetailerDetailsCard v-else-if="isRetailer" :retailer="retailerDetails" :show-on-map-button="false" />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

type Props = {
  id?: string;
  address?: string;
  email?: string;
  name?: string;
  openingHoursMondays?: string;
  openingHoursTuesdays?: string;
  openingHoursWednesdays?: string;
  openingHoursThursdays?: string;
  openingHoursFridays?: string;
  openingHoursSaturdays?: string;
  openingHoursSundays?: string;
  lat?: number;
  lng?: number;
  phone?: string;
  storeId?: string;
  label?: string;
  offerings?: string[];
  link?: string;
};

const props = withDefaults(defineProps<Props>(), {
  id: undefined,
  address: '',
  email: '',
  name: '',
  openingHoursMondays: '',
  openingHoursTuesdays: '',
  openingHoursWednesdays: '',
  openingHoursThursdays: '',
  openingHoursFridays: '',
  openingHoursSaturdays: '',
  openingHoursSundays: '',
  lat: undefined,
  lng: undefined,
  phone: '',
  storeId: '',
  label: '',
  offerings: () => [],
  link: '',
});

const { t } = useI18n();

const retailerDetails = computed(() => {
  return {
    name: props.name,
    address: props.address,
    offerings: props.offerings,
    link: props.link,
  };
});

const isRetailer = computed(() => {
  return props.name && !props.storeId;
});
</script>
<script lang="ts">
export default defineComponent({
  name: 'MapInfoWindow',
});
</script>
